import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";
import { ChevronUpIcon } from "src/icons";

import * as styles from "../LeftMenu.module.less";
import { LeftMenuGroupItem } from "../LeftMenuItem";
import { leftMenuStore } from "../leftMenuStore";
import { RenderLeftMenuItem2 } from ".";

export type PropsGroupItem = {
  item: LeftMenuGroupItem;
  closeMenu: () => void;
};

export const GroupItem: React.FC<PropsGroupItem> = observer(
  ({ item, closeMenu }) => {
    const isOpen = leftMenuStore.isGroupOpen(item.key);

    const handleToggle = () => {
      leftMenuStore.toggleGroup(item.key);
    };

    const handleKeyDown = (event: React.KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault();
        handleToggle();
      }
    };

    return (
      <>
        <div
          id={`group-${item.key}`}
          className={classNames([styles.menuItem, styles.groupHeader])}
          onClick={handleToggle}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          aria-expanded={isOpen}
          aria-label={`${item.label} - ${isOpen ? "свернуть" : "развернуть"} подменю`}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {item.icon}
            <span className={styles.label}>{item.label}</span>
          </div>
          <ChevronUpIcon
            className={classNames([styles.chevron, [!isOpen, styles.rotated]])}
          />
        </div>
        <div
          className={classNames([
            styles.subMenu,
            [isOpen, styles.expanded],
            [!isOpen, styles.collapsed],
          ])}
          role="region"
          aria-labelledby={`group-${item.key}`}
        >
          {item.items.map((sub) => (
            <RenderLeftMenuItem2
              key={sub.key}
              item={sub}
              closeMenu={closeMenu}
            />
          ))}
        </div>
      </>
    );
  },
);
